var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.availableLocales),function(lang,i){return _c('nice-button-2',{key:`Lang${i}`,staticClass:"locale-changer__button",attrs:{"filled":lang === _vm.$i18n.locale,"bordered":""},on:{"click":function($event){return _vm.updateLanguage(lang)}}},[_vm._v(" "+_vm._s(lang)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }